var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DateTime } from 'luxon';
import { DateRangeCalendar } from '@one-thd/sui-date-pickers';
import { Modal, ModalHeader, ModalBody, ModalFooter, Typography, Button, } from '@one-thd/sui-atomic-components';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
var isApplyDisabled = function (startDate, endDate) {
    if (((startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '') === '' &&
        ((endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '') === '')
        return true;
    if (startDate &&
        (startDate === null || startDate === void 0 ? void 0 : startDate.startOf('day')) <
            DateTime.now().minus({ months: 25 }).startOf('day'))
        return true;
    if (endDate && (endDate === null || endDate === void 0 ? void 0 : endDate.startOf('day')) > DateTime.now().startOf('day'))
        return true;
    return false;
};
export var CustomDateRangeModal = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, _b = _a.dateRangeState, startDate = _b.startDate, setStartDate = _b.setStartDate, endDate = _b.endDate, setEndDate = _b.setEndDate, setDateRangeOptions = _a.setDateRangeOptions, setPHRequest = _a.setPHRequest, handleModalClose = _a.handleModalClose;
    var maxDate = DateTime.now().startOf('day').toString();
    var minDate = DateTime.now()
        .minus({ months: 25 })
        .startOf('day')
        .toString();
    return (React.createElement(Modal, { open: open, onClose: handleClose, style: { zIndex: 2000000008 } },
        React.createElement(ModalHeader, { onClose: handleClose }, "Custom Date Range"),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-grid sui-grid-cols-1" },
                React.createElement(Typography, { variant: "body-lg" }, "Select date range for Purchase History."),
                React.createElement(DateRangeCalendar, { minDate: minDate, maxDate: maxDate, value: {
                        start: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '',
                        end: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '',
                    }, onChange: function (_event, value) {
                        setStartDate(DateTime.fromISO(value.start));
                        setEndDate(DateTime.fromISO(value.end));
                    } }))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement(Button, { variant: "secondary", onClick: function () {
                    setStartDate(null);
                    setEndDate(null);
                } }, "Clear"),
            React.createElement(Button, { variant: "primary", disabled: isApplyDisabled(startDate, endDate), onClick: function () {
                    if (setDateRangeOptions) {
                        setDateRangeOptions({
                            startDate: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '',
                            endDate: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '',
                        });
                        if (setPHRequest) {
                            setPHRequest(function (prevState) {
                                return __assign(__assign({}, prevState), { startDate: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '', endDate: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '', pageNumber: 1 });
                            });
                        }
                        handleClose();
                        if (handleModalClose)
                            handleModalClose();
                    }
                } }, "Apply"))));
};
